<div #box [class.active]="status === 1 || status === 2"
     [style.height.px]="height"
     [style.transform]="'translate3d('+ left + 'px,' + top + 'px,' + '0px)'"
     [style.width.px]="width"
     class="resizable-draggable"
>
    <iframe src="https://miro.com/app/live-embed/o9J_lV54_a0=/"></iframe>
    <div (mousedown)="setStatus($event, 1)" class="resize-action"></div>
    <div (mousedown)="setStatus($event, 2)"
         (window:mouseup)="setStatus($event, 0)"
         class="dragger"></div>
</div>
